<header class="bg-white/80 backdrop-blur-lg border-b border-gray-200/50 sticky top-0 z-50">
    <div 
        class="mx-auto px-8 py-4"
        [class.w-full]="type === 'full-width'"
        [class.mx-auto]="type === 'container'"
        [class.max-w-7xl]="type === 'container'"
    >
      <div class="flex items-center justify-between">
        <!-- Brand -->
        <div class="flex items-center space-x-3">
          <div>
            <img src="assets/images/dark-logo.png" alt="ezyhire" class="w-[120px] md:w-[200px]">
          </div>
        </div>
        
        <div class="flex items-center space-x-6" *ngIf="title">
          <div class="flex items-center space-x-4 text-xs font-medium text-gray-600">
            <div class="flex items-center space-x-1.5">
               <i-lucide *ngIf="icon" [name]="icon" class="w-4 h-4 text-gray-600"></i-lucide>
              <span>{{title}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
</header>